// extracted by mini-css-extract-plugin
export default {"wrapper":"Nj","form":"Oj","circle":"Pj","success":"Qj","button":"Rj"};